import React from "react";
import { FaTwitter, FaGithub, FaLinkedin } from "react-icons/fa";
import styled from "styled-components";
import Vikram from "../Assets/Vikram.png";

const socialMediaLinks = [
  {
    id: 0,
    link: "https://linkedin.com/in/vikram-amin-52b55815a",
    icon: <FaLinkedin />,
  },
  {
    id: 1,
    link: "https://github.com/Vikram-amin",
    icon: <FaGithub />,
  },
  {
    id: 2,
    link: "https://twitter.com/vikram56201675",
    icon: <FaTwitter />,
  },
];


const About = () => {
  return (
    <>
      <Container className="about">
        <br />
        <AboutDiv>
          <Column>
            <Img src={Vikram} alt="my image" />
          </Column>
          <Column>
            <H1>About </H1>
            <AboutInfo>
              <AboutInfoP>
                Aspiring web developer with robust component based developing
                skills. Collaborative, team player who is proficient in working
                with teams and building interactive web applications. Strongly
                interested in obtaining a developer position to work on
                enhancing product experience.
              </AboutInfoP>
            </AboutInfo>

            <HeaderUl>
              {socialMediaLinks.map((item) => (
                <HeaderIconDiv key={item.id}>
                  <a href={item.link} target="_blank" rel="noopener noreferrer">
                    <HeaderIcon>{item.icon}</HeaderIcon>
                  </a>
                </HeaderIconDiv>
              ))}
            </HeaderUl>
          </Column>
        </AboutDiv>
        <br />
      </Container>
    </>
  );
};



 const Container = styled.div`
  width: 95%;
  margin: auto;
  padding: 40px 0px;
  /* margin-bottom: 100px; */
`;

 const H1 = styled.div`
   font-size: 32px;
   margin-bottom: 20px;
   font-size: 2rem;
   font-weight: bold;
   color: ${(props) => props.theme.text.main};
 `;


 const AboutDiv = styled.div`
  width: 80%;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
`;

 const Column = styled.div`
  width: 50%;
  margin: auto;
  justify-content: center;
  @media (max-width: 870px) {
    width: 100%;
    text-align: center;
  }
`;

 const Img = styled.img`
  padding: 30px;
  width: 350px;
  height: 350px;
  border-radius: 50%;
  margin: auto;
  
  justify-content: center;
  // border: 1px solid black;
  @media (max-width: 445px) {
    /* margin-left: -35px; */
    /* width: 80%; */
    width: 350px;
    height: 350px;
    margin: auto;
    /* justify-self: center; */
    justify-items: center;
    justify-content: center/;
    /* padding : 0px; */
  }
`;

 const AboutInfo = styled.div`
  color: ${(props) => props.theme.text};
`;

 const AboutInfoP = styled.div`
   font-size: 18px;
   margin-bottom: 20px;
   color: ${(props) => props.theme.text.secondary};
 `;

 const HeaderUl = styled.div`
   width: 50%;
   list-style-type: none;
   display: flex;
   margin-bottom: 20px;
   margin-left: 25%;
   color: #fff;
   justify-content: center;
   align-items: center;

   @media (max-width: 650px) {
     justify-content: center;
   }
 `;

 const HeaderIconDiv = styled.div`
   margin-top: 30px;
   margin-bottom: 20px;
 `;

 const HeaderIcon = styled.div`
   width: 50px;
   height: 50px;
   background-color: ${(props) => props.theme.LightTheme.fontColorPrimary};
   color: ${(props) => props.theme.text.main};
   border-radius: 50%;
   display: flex;
   align-items: center;
   justify-content: center;
   margin: 0 10px;
   transition: all 0.5s linear;
   cursor: pointer;
   &:first-child {
     margin-left: 0;
   }
 `;
 


export default About;
